export default function NotFound() {
  const handleGoHome = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f8f9fa] to-[#ffffff] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-32 h-32 mx-auto mb-6 bg-[#ecad29] rounded-full flex items-center justify-center">
          <i className="ri-error-warning-line text-white text-6xl w-16 h-16 flex items-center justify-center"></i>
        </div>
        <h1 className="text-6xl font-bold text-gray-800 mb-2 font-['Oswald']">404</h1>
        <h2 className="text-xl font-semibold text-gray-700 mb-3">Sayfa Bulunamadı</h2>
        <p className="text-sm text-gray-500 mb-6">Aradığınız sayfa mevcut değil.</p>
        <button
          onClick={handleGoHome}
          className="bg-[#ecad29] text-white px-6 py-3 rounded-full text-sm font-medium shadow-lg hover:bg-[#d49a1f] transition-colors whitespace-nowrap cursor-pointer"
        >
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
}